import { render, staticRenderFns } from "./labeltype.vue?vue&type=template&id=94519998"
import script from "./labeltype.vue?vue&type=script&lang=js"
export * from "./labeltype.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports